(function () {
  const enableAutoplay = typeof window.enableAutoplay !== "undefined" ? window.enableAutoplay : !1;
  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.viewport = container.querySelector(".shop-gallery-viewport");
      this.track = container.querySelector(".shop-gallery-track");
      this.slides = Array.from(container.querySelectorAll(".shop-gallery-slide"));
      this.mainImages = Array.from(container.querySelectorAll(".shop-main-image"));
      this.thumbnails = Array.from(container.querySelectorAll(".shop-thumbnail"));
      this.dots = Array.from(container.querySelectorAll(".shop-dot"));
      this.desktopPrevArrow = container.querySelector(".shop-desktop-prev-arrow");
      this.desktopNextArrow = container.querySelector(".shop-desktop-next-arrow");
      this.mobilePrevArrows = Array.from(container.querySelectorAll(".shop-mobile-prev-arrow"));
      this.mobileNextArrows = Array.from(container.querySelectorAll(".shop-mobile-next-arrow"));
      this.indicatorsContainer = container.querySelector(".shop-indicators, #thumbnail-indicators");
      this.currentIndex = 0;
      this.maxIndex = (this.slides.length || this.mainImages.length) - 1;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.dragStartScrollLeft = 0;
      this.dragCurrentX = 0;
      this.dragDeltaX = 0;
      this.dragPointerId = null;
      this.isPointerDown = !1;
      this.isDragging = !1;
      this.dragIntent = null;
      this.prefersTouchEvents = "ontouchstart" in window || navigator.maxTouchPoints > 0;
      this.swipeThreshold = 30;
      this.scrollSyncFrame = null;
      this.scrollSyncTimer = null;
      this.scrollTargetIndex = null;
      this.scrollTargetTimer = null;
      this.scrollAnimationFrame = null;
      this.thumbnailScrollAnimationFrame = null;
      this.dragScrollFrame = null;
      this.dragTargetScrollLeft = null;
      this.videoReplayTimer = null;
      this.navigationToken = 0;
      this.init();
    }
    init() {
      this.createIndicators();
      this.attachEvents();
      this.updateActiveState(0);
      this.scrollToMedia(0, !1);
      this.handleVideoAutoplay(0);
      this.attachDragEvents();
      this.attachScrollEvents();
      window.addEventListener("resize", () => this.scrollToMedia(this.currentIndex, !1));
    }
    attachEvents() {
      this.thumbnails.forEach((thumb, i) => {
        thumb.addEventListener("click", () => this.changeImage(i));
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", () => this.changeImage(i));
        dot.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.changeImage(i);
          }
        });
      });
      if (this.desktopPrevArrow) {
        this.desktopPrevArrow.addEventListener("click", () => this.goToPreviousImage());
        this.desktopPrevArrow.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.goToPreviousImage();
          }
        });
      }
      if (this.desktopNextArrow) {
        this.desktopNextArrow.addEventListener("click", () => this.goToNextImage());
        this.desktopNextArrow.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.goToNextImage();
          }
        });
      }
      this.mobilePrevArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => this.goToPreviousImage());
          arrow.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.goToPreviousImage();
            }
          });
        }
      });
      this.mobileNextArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => this.goToNextImage());
          arrow.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.goToNextImage();
            }
          });
        }
      });
      if (this.indicatorsContainer) {
        this.indicatorsContainer.addEventListener("click", (e) => {
          const indicator = e.target.closest(".shop-indicator-dot");
          if (indicator && this.indicatorsContainer.contains(indicator)) {
            const idx = parseInt(indicator.getAttribute("data-index"));
            if (!isNaN(idx)) this.changeImage(idx);
          }
        });
      }
    }
    createIndicators() {
      if (!this.indicatorsContainer) return;
      this.indicatorsContainer.innerHTML = "";
      const indicatorCount = this.slides.length || this.mainImages.length;
      Array.from({ length: indicatorCount }).forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "shop-indicator-dot" + (i === 0 ? " active" : "");
        dot.setAttribute("data-index", i);
        dot.setAttribute("aria-label", `View image ${i + 1}`);
        this.indicatorsContainer.appendChild(dot);
      });
    }
    goToPreviousImage() {
      if (this.currentIndex <= 0) return;
      this.changeImage(this.currentIndex - 1);
    }
    goToNextImage() {
      if (this.currentIndex >= this.maxIndex) return;
      this.changeImage(this.currentIndex + 1);
    }
    changeImage(index) {
      if (index < 0 || index > this.maxIndex) return;
      const navigationToken = ++this.navigationToken;
      this.currentIndex = index;
      this.scrollToMedia(index, !0, () => {
        if (navigationToken !== this.navigationToken) return;
        this.updateActiveState(index, !1);
        this.handleVideoAutoplay(index);
      });
      this.scrollToThumbnail(index, () => {
        if (navigationToken !== this.navigationToken) return;
        this.updateActiveThumbnail(index);
      });
    }
    updateActiveState(index, updateThumbnail = !0) {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle("active", i === index);
        const zoomWrapper = slide.querySelector(".shop-image-zoom-wrapper");
        if (zoomWrapper) {
          zoomWrapper.classList.toggle("active", i === index);
        }
      });
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === index);
      });
      if (updateThumbnail) this.updateActiveThumbnail(index);
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });
      if (this.indicatorsContainer) {
        Array.from(this.indicatorsContainer.children).forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });
      }
      this.updateArrowState(index);
    }
    updateActiveThumbnail(index) {
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === index);
      });
    }
    updateArrowState(index) {
      const setDisabled = (arrows, disabled) => {
        arrows.forEach((arrow) => {
          if (!arrow) return;
          arrow.disabled = disabled;
          arrow.setAttribute("aria-disabled", disabled ? "true" : "false");
        });
      };

      setDisabled([this.desktopPrevArrow, ...this.mobilePrevArrows], index <= 0);
      setDisabled([this.desktopNextArrow, ...this.mobileNextArrows], index >= this.maxIndex);
    }
    setTrackPosition(index, animate, dragOffset) {
      if (!this.track) return;
      const isDragFrame = typeof dragOffset === "number";
      this.track.classList.toggle("is-dragging", isDragFrame);
      this.track.style.transition = animate ? "" : "none";
      if (this.viewport) {
        const offset = isDragFrame ? dragOffset : 0;
        this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
        if (!animate && !isDragFrame) {
          requestAnimationFrame(() => {
            if (this.track) this.track.style.transition = "";
          });
        }
        return;
      }
      const baseOffset = -index * 100;
      const offset = isDragFrame ? ` ${dragOffset < 0 ? "-" : "+"} ${Math.abs(dragOffset)}px` : "";
      this.track.style.transform = `translate3d(calc(${baseOffset}%${offset}), 0, 0)`;
      if (!animate && !isDragFrame) {
        requestAnimationFrame(() => {
          if (this.track) this.track.style.transition = "";
        });
      }
    }
    scrollToMedia(index, animate, onComplete) {
      this.cancelScrollSync();
      if (!this.viewport) {
        this.setTrackPosition(index, animate);
        return;
      }
      this.setTrackPosition(index, !1);
      this.scrollTargetIndex = index;
      window.clearTimeout(this.scrollTargetTimer);
      const targetLeft = index * this.viewport.clientWidth;
      if (!animate || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.cancelViewportScrollAnimation();
        this.viewport.scrollTo({ left: targetLeft, behavior: "auto" });
        if (typeof onComplete === "function") onComplete();
        this.scrollTargetTimer = window.setTimeout(() => {
          this.scrollTargetIndex = null;
          this.syncIndexFromScroll();
        }, 0);
        return;
      }
      this.animateViewportScroll(targetLeft, onComplete);
    }
    cancelScrollSync() {
      if (this.scrollSyncFrame) {
        window.cancelAnimationFrame(this.scrollSyncFrame);
        this.scrollSyncFrame = null;
      }
      window.clearTimeout(this.scrollSyncTimer);
      this.scrollSyncTimer = null;
    }
    cancelViewportScrollAnimation() {
      if (this.scrollAnimationFrame) {
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
      }
      if (this.viewport) {
        this.viewport.classList.remove("is-programmatic-scroll");
      }
    }
    animateViewportScroll(targetLeft, onComplete) {
      if (!this.viewport) return;
      this.cancelViewportScrollAnimation();
      const startLeft = this.viewport.scrollLeft;
      const distance = targetLeft - startLeft;
      if (Math.abs(distance) < 1) {
        this.viewport.scrollTo({ left: targetLeft, behavior: "auto" });
        this.scrollTargetIndex = null;
        if (typeof onComplete === "function") onComplete();
        this.syncIndexFromScroll();
        return;
      }

      const duration = 400;
      const startTime = performance.now();
      this.viewport.classList.add("is-programmatic-scroll");

      const animateStep = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const easedProgress = this.getGalleryTransitionProgress(progress);
        this.viewport.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.scrollAnimationFrame = window.requestAnimationFrame(animateStep);
          return;
        }

        this.viewport.scrollLeft = targetLeft;
        this.viewport.classList.remove("is-programmatic-scroll");
        this.scrollAnimationFrame = null;
        this.scrollTargetIndex = null;
        if (typeof onComplete === "function") onComplete();
        this.syncIndexFromScroll();
      };

      this.scrollAnimationFrame = window.requestAnimationFrame(animateStep);
    }
    scrollToThumbnail(index, onComplete) {
      if (!this.thumbnails[index]) return;
      const thumbnail = this.thumbnails[index];
      const container = thumbnail.parentElement;
      if (!container) return;
      const containerWidth = container.offsetWidth;
      const thumbnailWidth = thumbnail.offsetWidth;
      const thumbnailLeft = thumbnail.offsetLeft;
      const alignActiveFirst = window.matchMedia("(min-width: 768px)").matches;
      const scrollPosition = alignActiveFirst
        ? Math.max(0, thumbnailLeft - container.offsetLeft)
        : thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;
      this.animateThumbnailScroll(container, scrollPosition, onComplete);
    }
    cancelThumbnailScrollAnimation() {
      if (this.thumbnailScrollAnimationFrame) {
        window.cancelAnimationFrame(this.thumbnailScrollAnimationFrame);
        this.thumbnailScrollAnimationFrame = null;
      }
      const thumbnailContainer = this.thumbnails[0]?.parentElement;
      thumbnailContainer?.classList.remove("is-programmatic-scroll");
    }
    animateThumbnailScroll(container, targetLeft, onComplete) {
      this.cancelThumbnailScrollAnimation();
      const maximumScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const boundedTarget = Math.max(0, Math.min(maximumScroll, targetLeft));
      const startLeft = container.scrollLeft;
      const distance = boundedTarget - startLeft;

      if (
        Math.abs(distance) < 1 ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) {
        container.scrollTo({ left: boundedTarget, behavior: "auto" });
        if (typeof onComplete === "function") onComplete();
        return;
      }

      const duration = 400;
      const startTime = performance.now();
      container.classList.add("is-programmatic-scroll");

      const animateStep = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const easedProgress = this.getGalleryTransitionProgress(progress);
        container.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.thumbnailScrollAnimationFrame = window.requestAnimationFrame(animateStep);
          return;
        }

        container.scrollLeft = boundedTarget;
        container.classList.remove("is-programmatic-scroll");
        this.thumbnailScrollAnimationFrame = null;
        if (typeof onComplete === "function") onComplete();
      };

      this.thumbnailScrollAnimationFrame = window.requestAnimationFrame(animateStep);
    }
    getGalleryTransitionProgress(progress) {
      if (progress <= 0 || progress >= 1) return progress;

      let lowerBound = 0;
      let upperBound = 1;
      let curvePosition = progress;

      for (let iteration = 0; iteration < 10; iteration += 1) {
        curvePosition = (lowerBound + upperBound) / 2;
        const inversePosition = 1 - curvePosition;
        const curveX =
          3 * inversePosition * inversePosition * curvePosition * 0.25 +
          3 * inversePosition * curvePosition * curvePosition * 0.5 +
          curvePosition * curvePosition * curvePosition;

        if (curveX < progress) lowerBound = curvePosition;
        else upperBound = curvePosition;
      }

      const inversePosition = 1 - curvePosition;
      return (
        3 * inversePosition * inversePosition * curvePosition +
        3 * inversePosition * curvePosition * curvePosition +
        curvePosition * curvePosition * curvePosition
      );
    }
    attachDragEvents() {
      const imageContainer = this.container.querySelector(".shop-image-container");
      if (!imageContainer || !this.track || this.maxIndex <= 0) return;

      imageContainer.addEventListener("dragstart", (e) => e.preventDefault());
      imageContainer.querySelectorAll("img").forEach((img) => {
        img.setAttribute("draggable", "false");
      });

      if (window.PointerEvent) {
        imageContainer.addEventListener("pointerdown", (e) => this.handleDragStart(e.clientX, e.clientY, e.pointerId, e));
        imageContainer.addEventListener("pointermove", (e) => this.handleDragMove(e.clientX, e.clientY, e));
        imageContainer.addEventListener("pointerup", (e) => this.handleDragEnd(e));
        imageContainer.addEventListener("pointercancel", (e) => this.handleDragCancel(e));
        return;
      }

      imageContainer.addEventListener(
        "touchstart",
        (e) => {
          const touch = e.changedTouches[0];
          if (touch) this.handleDragStart(touch.clientX, touch.clientY, null, e);
        },
        { passive: !0 },
      );
      imageContainer.addEventListener(
        "touchmove",
        (e) => {
          const touch = e.changedTouches[0];
          if (touch) this.handleDragMove(touch.clientX, touch.clientY, e);
        },
        { passive: !1 },
      );
      imageContainer.addEventListener("touchend", (e) => this.handleDragEnd(e), { passive: !0 });
      imageContainer.addEventListener("touchcancel", (e) => this.handleDragCancel(e), { passive: !0 });
    }
    attachScrollEvents() {
      if (!this.viewport || this.maxIndex <= 0) return;
      this.viewport.addEventListener("scroll", () => this.handleViewportScroll(), { passive: !0 });
    }
    handleViewportScroll() {
      if (this.isDragging) {
        this.cancelScrollSync();
        return;
      }
      if (this.viewport?.classList.contains("is-programmatic-scroll")) return;
      if (this.scrollTargetIndex !== null && !this.isScrollAtIndex(this.scrollTargetIndex)) return;
      if (this.scrollTargetIndex !== null) this.scrollTargetIndex = null;

      if (!this.scrollSyncFrame) {
        this.scrollSyncFrame = requestAnimationFrame(() => {
          this.scrollSyncFrame = null;
          this.syncIndexFromScroll();
        });
      }

      window.clearTimeout(this.scrollSyncTimer);
      this.scrollSyncTimer = window.setTimeout(() => this.syncIndexFromScroll(), 120);
    }
    syncIndexFromScroll() {
      if (!this.viewport) return;
      const viewportWidth = this.viewport.clientWidth || 1;
      const index = Math.max(0, Math.min(this.maxIndex, Math.round(this.viewport.scrollLeft / viewportWidth)));
      if (index === this.currentIndex) return;

      this.currentIndex = index;
      this.updateActiveState(index);
      this.scrollToThumbnail(index);
      this.handleVideoAutoplay(index);
    }
    isScrollAtIndex(index) {
      if (!this.viewport) return !0;
      const targetLeft = index * this.viewport.clientWidth;
      return Math.abs(this.viewport.scrollLeft - targetLeft) <= 2;
    }
    handleDragStart(clientX, clientY, pointerId, event) {
      if (event && event.button !== undefined && event.button !== 0) return;
      if (this.viewport && event?.pointerType === "touch") return;
      this.dragStartX = clientX;
      this.dragStartY = clientY;
      this.dragStartScrollLeft = this.viewport?.scrollLeft || 0;
      this.dragCurrentX = clientX;
      this.dragDeltaX = 0;
      this.dragPointerId = pointerId;
      this.isPointerDown = !0;
      this.isDragging = !1;
      this.dragIntent = null;
      this.scrollTargetIndex = null;
      this.cancelScrollSync();
      window.clearTimeout(this.scrollTargetTimer);
      this.cancelViewportScrollAnimation();
    }
    handleDragMove(clientX, clientY, event) {
      if (!this.isPointerDown) return;
      const deltaX = clientX - this.dragStartX;
      const deltaY = clientY - this.dragStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      if (!this.dragIntent && (absX > 8 || absY > 8)) {
        this.dragIntent = absX > absY ? "horizontal" : "vertical";
        if (this.dragIntent === "horizontal" && event?.currentTarget?.setPointerCapture && this.dragPointerId !== null) {
          try {
            event.currentTarget.setPointerCapture(this.dragPointerId);
          } catch (error) {}
        }
      }

      if (this.dragIntent !== "horizontal") return;
      if (event?.cancelable) event.preventDefault();

      this.isDragging = !0;
      this.dragCurrentX = clientX;
      this.dragDeltaX = deltaX;

      if (this.viewport) {
        this.viewport.classList.add("is-dragging");
        this.track.classList.add("is-dragging");
        this.dragTargetScrollLeft = this.dragStartScrollLeft - deltaX;
        this.scheduleViewportDragScroll();
        return;
      }

      let boundedDelta = deltaX;
      if ((this.currentIndex === 0 && deltaX > 0) || (this.currentIndex === this.maxIndex && deltaX < 0)) {
        boundedDelta = deltaX * 0.35;
      }
      this.setTrackPosition(this.currentIndex, !1, boundedDelta);
    }
    handleDragEnd(event) {
      if (!this.isPointerDown) return;
      if (this.viewport) {
        this.flushViewportDragScroll();
        const nextIndex = this.getIndexFromScroll();
        this.resetDragState(event);
        this.changeImage(nextIndex);
        return;
      }

      const deltaX = this.dragDeltaX;
      const slideWidth = this.getSlideWidth();
      const snapThreshold = Math.min(Math.max(slideWidth * 0.18, this.swipeThreshold), 90);
      let nextIndex = this.currentIndex;

      if (this.dragIntent === "horizontal" && Math.abs(deltaX) > snapThreshold) {
        nextIndex = deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1;
        nextIndex = Math.max(0, Math.min(this.maxIndex, nextIndex));
      }

      this.resetDragState(event);
      this.changeImage(nextIndex);
    }
    handleDragCancel(event) {
      if (!this.isPointerDown) return;
      const index = this.currentIndex;
      this.resetDragState(event);
      this.changeImage(index);
    }
    resetDragState(event) {
      if (event?.currentTarget?.releasePointerCapture && this.dragPointerId !== null) {
        try {
          event.currentTarget.releasePointerCapture(this.dragPointerId);
        } catch (error) {}
      }
      if (this.viewport) {
        this.viewport.classList.remove("is-dragging");
        this.setTrackPosition(this.currentIndex, !1);
      }
      this.cancelViewportDragScroll();
      this.isPointerDown = !1;
      this.isDragging = !1;
      this.dragIntent = null;
      this.dragPointerId = null;
      this.dragDeltaX = 0;
      this.dragTargetScrollLeft = null;
    }
    scheduleViewportDragScroll() {
      if (!this.viewport || this.dragScrollFrame) return;
      this.dragScrollFrame = window.requestAnimationFrame(() => {
        this.dragScrollFrame = null;
        if (!this.viewport || !this.isDragging || this.dragTargetScrollLeft === null) return;
        this.viewport.scrollLeft = this.dragTargetScrollLeft;
      });
    }
    flushViewportDragScroll() {
      if (!this.viewport || this.dragTargetScrollLeft === null) return;
      if (this.dragScrollFrame) {
        window.cancelAnimationFrame(this.dragScrollFrame);
        this.dragScrollFrame = null;
      }
      this.viewport.scrollLeft = this.dragTargetScrollLeft;
    }
    cancelViewportDragScroll() {
      if (this.dragScrollFrame) {
        window.cancelAnimationFrame(this.dragScrollFrame);
        this.dragScrollFrame = null;
      }
    }
    getSlideWidth() {
      const viewport = this.viewport || this.container.querySelector(".shop-image-container");
      return viewport?.clientWidth || this.track?.clientWidth || 1;
    }
    getIndexFromScroll() {
      if (!this.viewport) return this.currentIndex;
      const viewportWidth = this.viewport.clientWidth || 1;
      return Math.max(0, Math.min(this.maxIndex, Math.round(this.viewport.scrollLeft / viewportWidth)));
    }
    handleVideoAutoplay(index) {
      window.clearTimeout(this.videoReplayTimer);
      this.videoReplayTimer = null;

      // Pause all videos first
      this.mainImages.forEach((img, i) => {
        const video = img.querySelector("video");
        if (video) {
          video.onended = null;
          video.pause();
          video.currentTime = 0;
        }
        // Pause external videos (YouTube/Vimeo)
        const iframe = img.querySelector("iframe");
        if (iframe) {
          const src = iframe.src;
          if (src.includes("youtube.com")) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
        }
      });
      
      const activeMedia = this.mainImages[index];
      if (!activeMedia) return;

      // Handle local videos
      const videoToPlay = activeMedia.querySelector("video");
      if (videoToPlay) {
        videoToPlay.controls = false;
        videoToPlay.loop = false;
        videoToPlay.muted = true;
        videoToPlay.playsInline = true;
        videoToPlay.onended = () => {
          window.clearTimeout(this.videoReplayTimer);
          this.videoReplayTimer = window.setTimeout(() => {
            if (this.mainImages[this.currentIndex] !== activeMedia) return;
            videoToPlay.currentTime = 0;
            videoToPlay.play().catch(() => {});
          }, 1500);
        };
        videoToPlay.play().catch(() => {});
      }
      
      if (enableAutoplay) {
        // Handle external videos (YouTube/Vimeo)
        const iframeToPlay = activeMedia.querySelector("iframe");
        if (iframeToPlay) {
          const src = iframeToPlay.src;
          if (src.includes("youtube.com")) {
            iframeToPlay.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframeToPlay.contentWindow.postMessage('{"method":"play"}', "*");
          }
        }
      }
    }
    updateWithVariant(variant) {
      let matchIndex = -1;
      if (variant && (variant.mediaId || variant.variantId || variant.imageUrl)) {
        this.mainImages.forEach((img, i) => {
          if (
            (variant.mediaId && img.dataset.mediaId == variant.mediaId) ||
            (variant.variantId && img.dataset.variantId == variant.variantId) ||
            (variant.imageUrl &&
              (img.src.includes(variant.imageUrl) || (img.dataset.src && img.dataset.src.includes(variant.imageUrl))))
          ) {
            matchIndex = i;
          }
        });
      }
      if (matchIndex >= 0) {
        this.changeImage(matchIndex);
      } else {
        this.changeImage(0);
      }
    }
  }
  const galleryRegistry = [];
  function initAll() {
    document.querySelectorAll(".product-gallery").forEach((container) => {
      if (!container.__galleryInstance) {
        const gallery = new ProductGallery(container);
        container.__galleryInstance = gallery;
        galleryRegistry.push(gallery);
      }
    });
  }
  document.addEventListener("variantImageSelected", function (e) {
    if (e.detail && (e.detail.variantId || e.detail.mediaId || e.detail.imageUrl)) {
      galleryRegistry.forEach((gallery) => gallery.updateWithVariant(e.detail));
    }
  });
  document.addEventListener("variant:imageChanged", function (e) {
    if (e.detail && (e.detail.variantId || e.detail.mediaId || e.detail.imageUrl)) {
      galleryRegistry.forEach((gallery) => gallery.updateWithVariant(e.detail));
    }
  });
  window.ProductGallery = { initAll, getAll: () => galleryRegistry };
  document.addEventListener("DOMContentLoaded", initAll);
})();
